import { AxiosInstance } from "axios";
import { CreateFeeCategoryDto, FeeCategoryDto, ApiDataResponse, ApiResponse } from "./Dtos";

// Fee Category service functions that use axios from useAxios hook
export const feeCategoryService = {
    async getAll(axiosClient: AxiosInstance, schoolId: string) {
        // Matches CreateFeeStructureModal usage
        return await this.getSchoolFeeCategories(axiosClient, schoolId);
    },

    async getSchoolFeeCategories(axiosClient: AxiosInstance, schoolId: string) {
        const response = await axiosClient.get<ApiDataResponse<FeeCategoryDto[]>>(`/api/feecategory/school/${schoolId}`);
        return response.data;
    },

    async create(axiosClient: AxiosInstance, data: CreateFeeCategoryDto) {
        // Matches CreateFeeStructureModal usage if it used create
        return await this.createFeeCategory(axiosClient, data);
    },

    async createFeeCategory(axiosClient: AxiosInstance, data: CreateFeeCategoryDto) {
        const response = await axiosClient.post<ApiDataResponse<FeeCategoryDto>>(`/api/feecategory`, data);
        return response.data;
    },

    async update(axiosClient: AxiosInstance, id: string, data: Partial<CreateFeeCategoryDto>) {
        // Matches EditFeeStructureModal usage if it used update
        return await this.updateFeeCategory(axiosClient, id, data);
    },

    async updateFeeCategory(axiosClient: AxiosInstance, id: string, data: Partial<CreateFeeCategoryDto>) {
        const response = await axiosClient.put<ApiResponse>(`/api/feecategory/${id}`, data);
        return response.data;
    },

    async delete(axiosClient: AxiosInstance, id: string) {
        return await this.deleteFeeCategory(axiosClient, id);
    },

    async deleteFeeCategory(axiosClient: AxiosInstance, id: string) {
        const response = await axiosClient.delete<ApiResponse>(`/api/feecategory/${id}`);
        return response.data;
    }
};
